<template>
    <LayoutHeader>
        <Steps />
        <StickyTopPolicyCard v-if="$route.meta.isNeedPolicyCard" />
        <router-view v-slot="{ Component }">
            <transition
                name="pageTransition"
                mode="out-in"
            >
                <component :is="Component" />
            </transition>
        </router-view>
    </LayoutHeader>
</template>
<script>
import Steps from '@/components/layout/Steps.vue';
import LayoutHeader from '@/components/layout/LayoutHeader.vue';
import StickyTopPolicyCard from '@/components/layout/StickyTopPolicyCard.vue';

export default {
    components: {
        Steps,
        StickyTopPolicyCard,
        LayoutHeader
    },
};
</script>
<style scoped>
.pageTransition-enter-active,
.pageTransition-leave-active {
    transition: opacity 0.5s ease;
}

.pageTransition-enter-from,
.pageTransition-leave-to {
    opacity: 0;
}
</style>
